export const pt = {
    'LOCALE.SITE.TTILE': 'Deadly Arcade',
    'LOCALE.GAME': 'Jogar',
    'LOCALE.CHARACTERES': 'Personagens',
    "LOCALE.VIDEO": 'Trailer',
    "LOCALE.RANKING": 'Ranking',
    "LOCALE.SOCIAL": 'Social',
    "LOCALE.SOUNDTRACK": 'Trilha sonora',
    "LOCALE.SCREENSHOTS": 'Telas',

    'LOCALE.VIDEO.BTN': 'Ilustração de um botão de TV',

    "LOCALE.GAME.BEST_SCORE": 'Melhor pontuação',

    "LOCALE.RANKING.HEADER.NAME": 'Nome',
    "LOCALE.RANKING.HEADER.COUNTRY": 'País',
    "LOCALE.RANKING.HEADER.SCORE": 'Pontos',
    "LOCALE.RANKING.PLACEHOLDER": 'Sem dados',

    "LOCALE.SHARE.WHATSAPP": "Compartilhar no Whatsapp",
    "LOCALE.SHARE.FACEBOOK": "Compartilhar no Facebook",
    "LOCALE.SHARE.TWITTER": "Compartilhar no Twitter",
    
    "LOCALE.SOUNDTRACK.PLAY": 'Iniciar som',
    "LOCALE.SOUNDTRACK.PAUSE": 'Pausar som',
    "LOCALE.SOUNDTRACK.CHOOSE": 'Selecione uma trilha',
    "LOCALE.SOUNDTRACK.THEME": 'Deadly Arcade',
    "LOCALE.SOUNDTRACK.CARTOON": 'Fase de Papel',
    "LOCALE.SOUNDTRACK.MEDIEVAL": 'Fase Helada',
    "LOCALE.SOUNDTRACK.TERROR": 'Fase Invertida',
    "LOCALE.SOUNDTRACK.ZOMBIE": 'Fase Apocalipse',
    
    "LOCALE.SOUNDTRACK.BUTTON.THEME": 'Selecionar música Deadly Arcade',
    "LOCALE.SOUNDTRACK.BUTTON.CARTOON": 'Selecionar música Fase de Papel',
    "LOCALE.SOUNDTRACK.BUTTON.MEDIEVAL": 'Selecionar música Fase Helada',
    "LOCALE.SOUNDTRACK.BUTTON.TERROR": 'Selecionar música Fase Invertida',
    "LOCALE.SOUNDTRACK.BUTTON.ZOMBIE": 'Selecionar música Fase Apocalipse',
    
    "LOCALE.IOC.ARG": "Argentina", 
    "LOCALE.IOC.BOL": "Bolivia", 
    "LOCALE.IOC.BRA": "Brasil", 
    "LOCALE.IOC.CHI": "Chile", 
    "LOCALE.IOC.COL": "Colômbia", 
    "LOCALE.IOC.CRC": "Costa Rica", 
    "LOCALE.IOC.CUB": "Cuba", 
    "LOCALE.IOC.ESA": "El Salvador", 
    "LOCALE.IOC.ECU": "Equador", 
    "LOCALE.IOC.GUA": "Guatemala", 
    "LOCALE.IOC.HAI": "Haiti", 
    "LOCALE.IOC.HON": "Honduras", 
    "LOCALE.IOC.MEX": "México", 
    "LOCALE.IOC.UNK": "Geral", 
    "LOCALE.IOC.NCA": "Nicarágua", 
    "LOCALE.IOC.PAN": "Panamá", 
    "LOCALE.IOC.PAR": "Paraguai", 
    "LOCALE.IOC.PER": "Peru", 
    "LOCALE.IOC.DOM": "República Dominicana", 
    "LOCALE.IOC.URU": "Uruguai", 
    "LOCALE.IOC.VEN": "Venezuela", 

    "LOCALE.ACCESSIBILITY.MARCUS.TITLE": "Sobre Marcus Lopez",
    "LOCALE.ACCESSIBILITY.MARCUS.ALTERNATIVE_IMAGE_DATA": "Ilustração de Marcus Lopez",
    "LOCALE.ACCESSIBILITY.MARCUS.BUTTON": 'Selecionar personagem Marcus Lopez',

    "LOCALE.ACCESSIBILITY.SAYA.TITLE": "Sobre Saya",
    "LOCALE.ACCESSIBILITY.SAYA.ALTERNATIVE_IMAGE_DATA": "Ilustração de Saya",
    "LOCALE.ACCESSIBILITY.SAYA.BUTTON": 'Selecionar personagem Saya',

    "LOCALE.ACCESSIBILITY.BILLY.TITLE": "Sobre Billy",
    "LOCALE.ACCESSIBILITY.BILLY.ALTERNATIVE_IMAGE_DATA": "Ilustração de Billy",
    "LOCALE.ACCESSIBILITY.BILLY.BUTTON": 'Selecionar personagem Billy',
    
    "LOCALE.ACCESSIBILITY.MARIA.TITLE": "Sobre Maria",
    "LOCALE.ACCESSIBILITY.MARIA.ALTERNATIVE_IMAGE_DATA": "Ilustração de Maria",
    "LOCALE.ACCESSIBILITY.MARIA.BUTTON": 'Selecionar personagem Maria',
    
    "LOCALE.ACCESSIBILITY.MASTER.TITLE": "Sobre Master Lin",
    "LOCALE.ACCESSIBILITY.MASTER.ALTERNATIVE_IMAGE_DATA": "Ilustração de Master Lin",
    "LOCALE.ACCESSIBILITY.MASTER.BUTTON": 'Selecionar personagem Master Lin',

    "LOCALE.ACCESSIBILITY.SCREENSHOT.1": "Captura de tela do gameplay 1",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.2": "Captura de tela do gameplay 2",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.3": "Captura de tela do gameplay 3",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.4": "Captura de tela do gameplay 4",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.5": "Captura de tela do gameplay 5",
    "LOCALE.ACCESSIBILITY.SCREENSHOT.6": "Captura de tela do gameplay 6",

    "LOCALE.LIGHTBOX.CLOSE": "Fechar",
    "LOCALE.LIGHTBOX.BACK": "Anterior",
    "LOCALE.LIGHTBOX.NEXT": "Próxima",

    
    "LOCALE.COUNTRY.PLACEHOLDER": "Selecionar país",
    "LOCALE.SCREENSHOT.PLACEHOLDER": "Selecionar tela",

}